:host{display:block;width:330px}:host h3-disable-with-tooltip-helper{width:inherit}.grid{display:grid;grid-template:"text  value" auto "input input" auto/1fr auto}.text{grid-area:text}.value{grid-area:value}input{grid-area:input}
/*# sourceMappingURL=objectless-view-settings-slider.component.css.map */
